import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Page404 from '../pages/page404'
import Login from '../pages/login'

import TaskAssign from '../pages/ai-report/taskAssign'
import TaskInput from '../pages/ai-report/taskInput'
import TaskCheck from '../pages/ai-report/taskCheck'
import TaskPublish from '../pages/ai-report/taskPublish'

import Function from '../pages/admin/function'
import Param from '../pages/admin/param'
import Role from '../pages/admin/role'
import User from '../pages/admin/user'
import Info from '../pages/admin/info'
import Notice from '../pages/admin/notice'
import Help from '../pages/admin/help'
import HelpEdit from '../pages/admin/help/edit'

import AiReportHome from '../pages/ai-report/aiReportHome'
import AiReportView from '../pages/ai-report/aiReportView'
import AiReportCheck from '../pages/ai-report/aiReportCheck'

import DigitalAssessTaskAssign from '../pages/digitalAssess/taskAssign'
import DigitalAssessAnalyseReport from '../pages/digitalAssess/analyseReport'
import DigitalAssessIndexInput from '../pages/digitalAssess/indexInput'
import HelpView from '../pages/admin/help/view'

export const MyRouter = function () {
  return (
    <Switch>
      <Route key="101" exact={true} path="/login" component={Login}></Route>
      <Route key="102" exact={true} path="/page404" component={Page404}></Route>

      <Route key="103" exact={true} path="/ai-report" component={TaskAssign}></Route>
      <Route key="104" exact={true} path="/help" component={Page404}></Route>
      <Route key="105" exact={true} path="/about" component={Page404}></Route>
      <Route key="106" exact={true} path="/admin" component={Function}></Route>

      <Route key="10301" exact={true} path="/ai-report/taskAssign" component={TaskAssign}></Route>
      <Route key="10302" exact={true} path="/ai-report/taskInput" component={TaskInput}></Route>
      <Route key="10303" exact={true} path="/ai-report/taskCheck" component={TaskCheck}></Route>
      <Route key="10304" exact={true} path="/ai-report/taskPublish" component={TaskPublish}></Route>

      <Route key="10501" exact={true} path="/ai-report/reportview/" component={AiReportHome}></Route>
      <Route key="10502" exact={true} path="/ai-report/reportview/:symbol?" component={AiReportView}></Route>
      <Route key="10503" exact={true} path="/ai-report/reportcheck/" component={AiReportCheck}></Route>

      <Route key="10601" exact={true} path="/admin/function" component={Function}></Route>
      <Route key="10602" exact={true} path="/admin/user/:rtype?" component={User}></Route>
      <Route key="10605" exact={true} path="/admin/param" component={Param}></Route>
      <Route key="10603" exact={true} path="/admin/role" component={Role}></Route>
      <Route key="10610" exact={true} path="/admin/info" component={Info}></Route>
      <Route key="10610" exact={true} path="/admin/notice" component={Notice}></Route>
      <Route key="10611" exact={true} path="/admin/help" component={Help}></Route>
      <Route key="1061101" exact={true} path="/admin/help/:id" component={HelpView}></Route>
      <Route key="1061102" exact={true} path="/admin/help/:id/edit/:parentId?" component={HelpEdit}></Route>

      <Route key={'10701'} exact path="/digitalAssess/taskAssign" component={DigitalAssessTaskAssign} />
      <Route key={'10702'} exact path="/digitalAssess/indexInput" component={DigitalAssessIndexInput} />
      <Route key={'10703'} exact path="/digitalAssess/analyseReport" component={DigitalAssessAnalyseReport} />

      <Redirect key="9901" from="/*" to="/page404" />
    </Switch>
  )
}
